@if (toasts().length > 0) {
  <section class="position-fixed top-0 start-50 translate-middle-x mt-3 pt-5 w-auto pe-none d-flex flex-column gap-2" style="z-index: 2000">
    @for (toast of toasts(); track toast.id) {
      <article [class]="'alert alert-dismissible d-flex align-items-start gap-3 shadow rounded-3 mb-0 pe-auto ' + variantClassMap[toast.variant] + (toast.customClass ? ' ' + toast.customClass : '')" role="alert">
        <div class="flex-grow-1 min-w-0">
          @if (toast.title) {
            <h6 class="alert-heading mb-1 fs-6 fw-semibold">{{ toast.title }}</h6>
          }

          <p class="mb-0 small text-break">{{ toast.message }}</p>
        </div>

        @if (toast.dismissible) {
          <button type="button" class="btn-close flex-shrink-0" title="Close notification" (click)="dismiss(toast.id)"></button>
        }
      </article>
    }
  </section>
}
